module.exports = __webpack_public_path__ + "myanmar.svg?3cb6a5c769ea32cee8f6c1ed02529d5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/myanmar.svg
// module id = 240
// module chunks = 10